import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../public/components/Button';
import { useToken } from '../hooks/useToken';
import { useExchangeOTPMutation } from './mutations/exchangeOTPMutation';
import { useSendOTPMutation } from './mutations/sendOTPMutation';
import Header from "../../public/components/Header";

export function AuthView() {
  const navigate = useNavigate();

  const [_, setToken] = useToken(false);

  const [showCodeField, setShowCodeField] = useState(false);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');

  const [sendOTP, { error: sendOTPError, loading: sendOTPLoading }] =
    useSendOTPMutation({
      variables: { email },
      onCompleted: () => setShowCodeField(true),
      onError: () => {},
    });

  const [
    exchangeOTP,
    { error: exchangeOTPError, loading: exchangeOTPLoading },
  ] = useExchangeOTPMutation({
    variables: { email, code },
    onCompleted: (data) => {
      setToken(data.exchangeOTP);
      navigate('/admin');
    },
    onError: () => {},
  });

  const error = useMemo(
    () => sendOTPError ?? exchangeOTPError ?? null,
    [sendOTPError, exchangeOTPError],
  );

  return (
      <div className="min-h-screen flex flex-col bg-ui-background text-white">
        <div className="flex-shrink-0">
          <Header />
        </div>
        <div className="flex flex-grow items-center justify-center">
      <div className="max-w-sm w-full bg-black bg-opacity-20 p-5 space-y-3">
        <div>
          <input
            className="bg-white text-black px-3 py-2 shadow-md w-full"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
          />
        </div>

        {showCodeField && (
          <div>
              <div className="pb-2 text-sm">Please enter the code that was sent to your email</div>
              <div>
                  <input
                      className="bg-white text-black px-3 py-2 shadow-md w-full"
                      type="text"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      placeholder="Code"
                  />
          </div>
          </div>
        )}

        {error && <p className="text-red-700">{error.message}</p>}

        <Button
          loading={sendOTPLoading || exchangeOTPLoading}
          onClick={() => {
            if (showCodeField) exchangeOTP();
            else sendOTP();
          }}
        >
          {showCodeField ? 'Verify' : 'Login'}
        </Button>
      </div>
      </div>
      </div>
  );
}
